import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "theSidebarMenu",
  class: "collapse d-block position-sticky bg-primary text-light"
}
const _hoisted_2 = {
  key: 0,
  class: "text-center text-bg-warning fw-700 d-flex justify-content-between align-items-center w-100"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "DEV", -1)
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "sync", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "text-center text-bg-danger fw-700 d-flex justify-content-between align-items-center w-100"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "PROD", -1)
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "sync", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "fw-700 w-100 ps-3 pt-1"
}
const _hoisted_15 = {
  key: 3,
  id: "sidebarCollapse"
}
const _hoisted_16 = {
  key: 1,
  class: "collapse d-block position-sticky bg-primary text-light"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomerChanger = _resolveComponent("CustomerChanger")!
  const _component_SubMenuItem = _resolveComponent("SubMenuItem")!
  const _component_MenuItem = _resolveComponent("MenuItem")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("button", {
          class: "show-hide-menu-button bg-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideMenu && _ctx.hideMenu(...args)))
        }, "<<"),
        (_ctx.AuthContext.isAuthenticated() && _ctx.AuthContext.isDpUser())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.AppContext.isDev())
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _hoisted_3,
                    _hoisted_4,
                    _createElementVNode("a", {
                      href: _ctx.config.read('appUrlProd')
                    }, _hoisted_7, 8, _hoisted_5)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.AppContext.isProd())
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createElementVNode("a", {
                      href: _ctx.config.read('appUrlDev')
                    }, _hoisted_13, 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.getCustomerMainLicense)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('mainLicense') + ': ' + _ctx.getCustomerMainLicense?.description), 1))
          : _createCommentVNode("", true),
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createBlock(_component_CustomerChanger, {
              key: 2,
              class: "customer my-3"
            }))
          : _createCommentVNode("", true),
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_ctx.AbilityContext.isAuthorizedForAnyFeature('BASIC_HOMEPAGE_CONTENTBLOCKS', 'BASIC_HOMEPAGE_META_ABSTRACT'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 0,
                    title: _ctx.$t('homepage'),
                    icon: "home"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.AbilityContext.isAuthorizedForFeature('BASIC_HOMEPAGE_CONTENTBLOCKS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 0,
                            to: {name: 'header-photo'},
                            title: _ctx.$t('headerImage')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('BASIC_HOMEPAGE_CONTENTBLOCKS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 1,
                            to: {name: 'general-message'},
                            title: _ctx.$t('notifications')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('BASIC_HOMEPAGE_CONTENTBLOCKS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 2,
                            to: {name: 'welcome-text'},
                            title: _ctx.$t('welcomeText')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('BASIC_HOMEPAGE_CONTENTBLOCKS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 3,
                            to: {name: 'standard-homepage-content-blocks'},
                            title: _ctx.$t('standardContentBlocks')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('BASIC_HOMEPAGE_META_ABSTRACT') && _ctx.AuthContext.isDpUser())
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 4,
                            to: {name: 'basic-home-page-meta'},
                            title: "Metadata"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('HOMEPAGE_CONTENT_PAGE'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 1,
                    title: _ctx.$t('homepage'),
                    icon: "home",
                    to: {name: 'edit-homepage'},
                    onToggleMenu: _ctx.toggleMenu
                  }, null, 8, ["title", "onToggleMenu"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('WEBSITE_CONTENT_PAGE'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 2,
                    title: _ctx.$t('webPages'),
                    icon: "newsmode",
                    to: {name: 'content-pages'},
                    onToggleMenu: _ctx.toggleMenu
                  }, null, 8, ["title", "onToggleMenu"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_WEBSITE_MENU'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 3,
                    icon: "menu_open",
                    title: _ctx.$t('menus'),
                    to: {name: 'menus'},
                    onToggleMenu: _ctx.toggleMenu
                  }, null, 8, ["title", "onToggleMenu"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('POPUPS'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 4,
                    title: _ctx.$t('popups'),
                    icon: "chat_info",
                    to: {name: 'popups'},
                    onToggleMenu: _ctx.toggleMenu
                  }, null, 8, ["title", "onToggleMenu"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('CONTENT_PAGE_SNIPPETS'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 5,
                    title: _ctx.$t('snippets'),
                    icon: "magnify_docked",
                    to: {name: 'snippets'},
                    onToggleMenu: _ctx.toggleMenu
                  }, null, 8, ["title", "onToggleMenu"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForAnyFeature('BANNERS', 'CREATE_CUSTOM_BANNERS'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 6,
                    title: _ctx.$t('banners'),
                    icon: "planner_banner_ad_pt"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.AbilityContext.isAuthorizedForFeature('CREATE_CUSTOM_BANNERS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 0,
                            to: {name: 'customer-banners-overview'},
                            title: _ctx.$t('banners')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('BANNERS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 1,
                            to: {name: 'customer-banner-slots'},
                            title: _ctx.$t('bannerSlots')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_BANNER_SLOT_TO_FOLLOW'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 7,
                    title: _ctx.$t('bannerSlotsToFollow'),
                    icon: "check_box_outline_blank",
                    to: {name: 'content-provider-banner-slots'},
                    onToggleMenu: _ctx.toggleMenu
                  }, null, 8, ["title", "onToggleMenu"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForAnyFeature('WEBSHOP_INFO_PAGES', 'GENERAL_TERMS', 'PRIVACY_POLICY'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 8,
                    title: _ctx.$t('fixedPages'),
                    icon: "description"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.AbilityContext.isAuthorizedForFeature('GENERAL_TERMS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 0,
                            to: {name: 'general-terms'},
                            title: _ctx.$t('generalTerms')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('PRIVACY_POLICY'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 1,
                            to: {name: 'privacy-policy'},
                            title: _ctx.$t('privacyPolicy')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('WEBSHOP_INFO_PAGES'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 2,
                            to: {name: 'edit-named-page', params: {code: 'WS_INFO_PAGE_ORDER'}},
                            title: _ctx.$t('webshopInfoPageOrder')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('WEBSHOP_INFO_PAGES'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 3,
                            to: {name: 'edit-named-page', params: {code: 'WS_INFO_PAGE_PAY'}},
                            title: _ctx.$t('webshopInfoPagePay')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('WEBSHOP_INFO_PAGES'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 4,
                            to: {name: 'edit-named-page', params: {code: 'WS_INFO_PAGE_SHIPPING_AND_DELIVERY'}},
                            title: _ctx.$t('webshopInfoPageShippingAndDelivery')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('WEBSHOP_INFO_PAGES'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 5,
                            to: {name: 'edit-named-page', params: {code: 'WS_INFO_PAGE_POST_SALE_ASSISTANCE'}},
                            title: _ctx.$t('webshopInfoPagePostSaleAssistance')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('WEBSHOP_INFO_PAGES'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 6,
                            to: {name: 'edit-named-page', params: {code: 'WS_INFO_PAGE_RETURN_POLICY_AND_COMPLAINTS'}},
                            title: _ctx.$t('webshopInfoPageReturnPolicyAndComplaints')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_WEBSITE_CONTENT'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 9,
                    title: _ctx.$t('layout'),
                    icon: "brush"
                  }, {
                    default: _withCtx(() => [
                      true
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 0,
                            to: {name: 'logo'},
                            title: _ctx.$t('logo')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('STICKY_LOGO'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 1,
                            to: {name: 'sticky-logo'},
                            title: _ctx.$t('stickyLogo')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('CUSTOM_HEADER_STACK'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 2,
                            to: {name: 'headers'},
                            title: _ctx.$t('headers')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('CUSTOM_FOOTER_STACK'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 3,
                            to: {name: 'footers'},
                            title: _ctx.$t('footers')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('COLOR_SCHEME'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 4,
                            to: {name: 'theme-settings'},
                            title: _ctx.$t('themeSettings')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AuthContext.isDpUser() && _ctx.AbilityContext.isAuthorizedForFeature('CUSTOM_CSS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 5,
                            to: {name: 'custom-css'},
                            title: "Custom CSS"
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.AuthContext.isDpUser() && _ctx.AbilityContext.isAuthorizedForFeature('CUSTOM_JS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 6,
                            to: {name: 'custom-js'},
                            title: "Custom JS"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.AuthContext.isDpUser())
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 10,
                    title: _ctx.$t('previews'),
                    icon: "preview"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SubMenuItem, {
                        to: {name: 'custom-css-preview'},
                        title: _ctx.$t('customCssPreviews')
                      }, null, 8, ["title"]),
                      _createVNode(_component_SubMenuItem, {
                        to: {name: 'content-previews'},
                        title: _ctx.$t('fullPreviews')
                      }, null, 8, ["title"])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('OPENING_HOURS'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 11,
                    title: _ctx.$t('openingHours'),
                    icon: "schedule"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SubMenuItem, {
                        to: {name: 'standard-hours'},
                        title: _ctx.$t('standardOpeningHours')
                      }, null, 8, ["title"]),
                      _createVNode(_component_SubMenuItem, {
                        to: {name: 'exceptional-hours'},
                        title: _ctx.$t('exceptionalOpeningHours')
                      }, null, 8, ["title"]),
                      _createVNode(_component_SubMenuItem, {
                        to: {name: 'closing-periods'},
                        title: _ctx.$t('closingPeriods')
                      }, null, 8, ["title"])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForAnyFeature('MGMT_PHARMACY_DATA', 'PHARMACY_LANDING_PAGE', 'PHARMACY_ON_CALL_URL', 'REIMBURSED_CARE_RATES_DOCUMENT', 'ABOUT_US'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 12,
                    title: _ctx.pharmacyOrCompanyLabel('pharmacy', 'company', true),
                    icon: _ctx.pharmacyOrCompanyLabel('medical_information', 'source_environment', false)
                  }, {
                    default: _withCtx(() => [
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_PHARMACY_DATA'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 0,
                            to: {name: 'pharmacy-info'},
                            title: _ctx.$t('contactInfo')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_SETTINGS_EMAIL'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 1,
                            to: {name: 'emails'},
                            title: _ctx.$t('emails')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('ABOUT_US'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 2,
                            to: {name: 'about-us'},
                            title: _ctx.$t('aboutUs')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('ABOUT_US'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 3,
                            to: {name: 'team-members'},
                            title: _ctx.$t('teamMembers')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('PHARMACY_LANDING_PAGE'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 4,
                            to: {name: 'pharmacy-landing-page'},
                            title: _ctx.$t('landingPage')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('PHARMACY_ON_CALL_URL'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 5,
                            to: {name: 'pharmacy-on-call'},
                            title: _ctx.$t('pharmacyOnCall')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('REIMBURSED_CARE_RATES_DOCUMENT'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 6,
                            to: {name: 'reimburesed-care-rates'},
                            title: _ctx.$t('reimburesedCareRates')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title", "icon"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('ORCA'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 13,
                    title: _ctx.$t('reservationCampaigns'),
                    icon: "campaign",
                    to: {name: 'reservation-campaigns'},
                    onToggleMenu: _ctx.toggleMenu
                  }, null, 8, ["title", "onToggleMenu"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_CATALOG_SETTINGS'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 14,
                    title: _ctx.$t('catalog'),
                    icon: "storefront"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_CATALOG_PRODUCTS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 0,
                            to: {name: 'catalog-products-overview'},
                            title: _ctx.$t('products')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (!_ctx.AbilityContext.isAuthorizedForFeature('HIDE_PHARMACY_CONCEPTS') && _ctx.AbilityContext.isAuthorizedForFeature('CUSTOMER_CATALOG'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 1,
                            to: {name: 'product-selection'},
                            title: _ctx.$t('productChoice')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('CUSTOMER_PRODUCT'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 2,
                            to: {name: 'customer-products'},
                            title: _ctx.$t('ownProducts')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('STARTER_PRODUCT_BRAND_SELECTION'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 3,
                            to: {name: 'starter-product-selection'},
                            title: _ctx.$t('productChoice')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('PRODUCTS_IN_THE_SPOTLIGHT') && !_ctx.AbilityContext.isAuthorizedForFeature('NAMED_PRODUCT_FILTER'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 4,
                            to: {name: 'products-spotlight'},
                            title: _ctx.$t('productsInTheSpotlight')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('PREDEFINED_PRODUCT_FILTERS_CONDITIONS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 5,
                            to: {name: 'product-filters'},
                            title: _ctx.$t('productFilters')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('DP_REF_PRICE_SETTINGS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 6,
                            to: {name: 'base-prices'},
                            title: _ctx.$t('basePrices')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('CUSTOMER_CATALOG'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 7,
                            to: {name: 'discounts-price-lists'},
                            title: `${_ctx.$t('discounts')} ${_ctx.$t('and')} ${_ctx.$t('priceLists').toLowerCase()}`
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('STARTER_PRODUCT_DISCOUNT'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 8,
                            to: {name: 'starter-discounts'},
                            title: _ctx.$t('discount')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (!_ctx.AbilityContext.isAuthorizedForFeature('HIDE_PHARMACY_CONCEPTS') && _ctx.AbilityContext.isAuthorizedForFeature('CUSTOMER_CATALOG'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 9,
                            to: {name: 'sort-settings'},
                            title: _ctx.$t('sortSettings')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_CATALOG_CATEGORIES'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 10,
                            to: {name: 'categories'},
                            title: _ctx.$t('categoryManagement')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_CATALOG_CONTENT') && (_ctx.$can('use-license', 'PHARMACOLLECT_APB') || _ctx.$can('use-license', 'PHARMACOLLECT_PLUS_APB')))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 11,
                            to: {name: 'catalog-title'},
                            title: _ctx.$t('catalogTitle')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('CATEGORIES_CONTENT_BLOCK'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 12,
                            to: {name: 'categories-content-block'},
                            title: _ctx.$t('categoriesContentBlock')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('ALTERNATIVE_DELIVERY_METHODS'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 13,
                            to: {name: 'delivery-methods'},
                            title: _ctx.$t('deliveryMethods')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('PRODUCT_CATALOG'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 14,
                            to: {name: 'delivery-method-texts'},
                            title: _ctx.$t('deliveryMethodTexts')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('ALTERNATIVE_DELIVERY_METHODS_SHIPPING'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 15,
                            to: {name: 'delivery-cost-rules'},
                            title: _ctx.$t('deliveryCosts')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('ALT_DEL_METHOD_SHIPPING_TO_PICKUP_POINT'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 16,
                            to: {name: 'delivery-pickup-locations'},
                            title: _ctx.$t('deliveryPickupLocations')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('ORDER_LABELS_ASSIGNED_BY_DOCTOR'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 17,
                            to: {name: 'order-label-content-blocks'},
                            title: _ctx.$t('orderLabels')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_SHARED_CATALOG_SETTINGS'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 15,
                    title: _ctx.$t('catalog'),
                    icon: "storefront"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.AbilityContext.isAuthorizedForFeature('PRODUCT_CATALOG'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 0,
                            to: {name: 'delivery-method-texts'},
                            title: _ctx.$t('deliveryMethodTexts')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('ALTERNATIVE_DELIVERY_METHODS_SHIPPING'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 1,
                            to: {name: 'delivery-cost-rules'},
                            title: _ctx.$t('deliveryCosts')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('PHARMACY_SW_SYNC') && !_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_CATALOG_SETTINGS'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 16,
                    title: _ctx.$t('catalog'),
                    icon: "storefront"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SubMenuItem, {
                        to: {name: 'pharmacy-software'},
                        title: _ctx.$t('pharmacySoftware')
                      }, null, 8, ["title"])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_FALLBACK_CONTENT'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 17,
                    title: _ctx.$t('fallbackContent'),
                    icon: "storefront"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_FALLBACK_CONTENT'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 0,
                            to: {name: 'delivery-method-fallback-texts'},
                            title: _ctx.$t('deliveryMethodTexts')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('REIMBURSED_CARE_RATES_DOCUMENT'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 1,
                            to: {name: 'reimburesed-care-rates'},
                            title: _ctx.$t('reimburesedCareRates')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_NOTIFICATION_TEMPLATE') && _ctx.AuthContext.isDpUser())
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 2,
                            to: {name: 'notification-templates'},
                            title: _ctx.$t('notificationTemplates')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_NOTIFICATION_TEMPLATE') && _ctx.AuthContext.isDpUser())
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 3,
                            to: {name: 'mailing-mail-templates'},
                            title: _ctx.$t('mailingTemplates')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_LIB_CONTENT'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 18,
                    title: _ctx.$t('libraries'),
                    icon: "library_books"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_LIB_CONTENT_LOGO'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 0,
                            to: {name: 'libraries-available', params: {cb_structure: _ctx.ContentBlockTypesEnum.LOGO}},
                            title: _ctx.$t('librariesLogo')
                          }, null, 8, ["to", "title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_LIB_CONTENT_IMAGE'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 1,
                            to: {name: 'libraries-available', params: {cb_structure: _ctx.ContentBlockTypesEnum.IMAGE}},
                            title: _ctx.$t('librariesImage')
                          }, null, 8, ["to", "title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_LIB_CONTENT_TWT'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 2,
                            to: {name: 'libraries-available', params: {cb_structure: _ctx.ContentBlockTypesEnum.TEXT_WITH_TITLE}},
                            title: _ctx.$t('librariesTextWithTitle')
                          }, null, 8, ["to", "title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_LIB_CONTENT_TWI'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 3,
                            to: {name: 'libraries-available', params: {cb_structure: _ctx.ContentBlockTypesEnum.TEXT_WITH_IMAGE}},
                            title: _ctx.$t('librariesTextWithImage')
                          }, null, 8, ["to", "title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_LIB_CONTENT_CONTENT_PAGE'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 4,
                            to: {name: 'libraries-available', params: {cb_structure: _ctx.LibraryStructureTypeEnum.CONTENT_PAGE}},
                            title: _ctx.$t('librariesContentPage')
                          }, null, 8, ["to", "title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_LIB_CONTENT_ARTICLE_ABSTRACT'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 5,
                            to: {name: 'libraries-available', params: {cb_structure: _ctx.LibraryStructureTypeEnum.ARTICLE_ABSTRACT}},
                            title: _ctx.$t('librariesArticleAbstract')
                          }, null, 8, ["to", "title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_LIB_CONTENT_BANNER'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 6,
                            to: {name: 'libraries-available', params: {cb_structure: _ctx.ContentBlockTypesEnum.BANNER}},
                            title: _ctx.$t('librariesBanner')
                          }, null, 8, ["to", "title"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.$can('use-license', 'CP_PHARMA_PIM') || _ctx.$can('use-license', 'CP_PRODUCT_CATEGORY') || _ctx.$can('use-license', 'CP_LABO'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 19,
                    title: "PharmaPIM",
                    icon: "database"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.AbilityContext.isAuthorizedForFeature('PIM_PRODUCT_INFO_OVERVIEW') && !_ctx.$can('use-license', 'CP_LABO'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 0,
                            to: {name: 'pim-products-overview'},
                            title: _ctx.$t('products')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('PIM_PRODUCT_INFO_OVERVIEW') && _ctx.$can('use-license', 'CP_LABO'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 1,
                            to: {name: 'pim-lab-products-overview'},
                            title: _ctx.$t('products')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('PIM_PRODUCT_CATEGORY'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 2,
                            to: {name: 'pim-export'},
                            title: "CSV export"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('CONTENT_PAGE_PRICE_CARD'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 20,
                    title: _ctx.$t('priceCards'),
                    icon: "sell",
                    to: {name: 'price-cards'},
                    onToggleMenu: _ctx.toggleMenu
                  }, null, 8, ["title", "onToggleMenu"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_SETTINGS'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 21,
                    title: _ctx.$t('generalSettings'),
                    icon: "settings"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_WEBSITE_CONTENT') && _ctx.AbilityContext.isAuthorizedForFeature('MGMT_PHARMACY_LOGO'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 0,
                            to: {name: 'pharmacollect-logo'},
                            title: _ctx.$t('logo')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (!_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_WEBSITE_CONTENT') && _ctx.AbilityContext.isAuthorizedForFeature('COLOR_SCHEME'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 1,
                            to: {name: 'theme-settings'},
                            title: _ctx.$t('themeSettings')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('GOOGLE_TAG_MANAGER'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 2,
                            to: {name: 'gtm-settings'},
                            title: "Google tag manager"
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_SETTINGS_EMAIL') && !_ctx.AbilityContext.isAuthorizedForFeature('MGMT_PHARMACY_DATA'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 3,
                            to: {name: 'emails'},
                            title: _ctx.$t('emails')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('LINK_TO_HOMEPAGE'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 4,
                            to: {name: 'pharmacollect-homepage'},
                            title: (_ctx.$can('use-license', 'PHARMACOLLECT_APB') || _ctx.$can('use-license', 'PHARMACOLLECT_PLUS_APB')) ? _ctx.$t('apbHomepage') : _ctx.$t('pharmacollectHomepage')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (!_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_WEBSITE_CONTENT') && _ctx.AbilityContext.isAuthorizedForFeature('PHARMACY_ON_CALL_URL'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 5,
                            to: {name: 'pharmacy-on-call'},
                            title: _ctx.$t('pharmacyOnCall')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_WEBSITE_CONTENT'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 6,
                            to: {name: 'pharma-appointments'},
                            title: _ctx.$t('calendarSettings')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_WEBSITE_CONTENT'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 7,
                            to: {name: 'pharma-pay'},
                            title: _ctx.$t('paymentSettings')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_WEBSITE_CONTENT'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 8,
                            to: {name: 'pharma-shipping'},
                            title: _ctx.$t('shippingSettings')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_PHARMACY_GROUP_INFO'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 9,
                            to: {name: 'pharmacy-group'},
                            title: _ctx.$t('pharmacyGroup')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (_ctx.AbilityContext.isAuthorizedForFeature('USER_REGISTRATION_RULES'))
                        ? (_openBlock(), _createBlock(_component_SubMenuItem, {
                            key: 10,
                            to: {name: 'user-registration-rules'},
                            title: _ctx.$t('userRegistrationRules')
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              _createVNode(_component_MenuItem, {
                title: _ctx.$t('needHelp') + '?',
                icon: "help",
                to: {name: 'support'},
                id: "menuItemHelp",
                class: "bg-primary-dark mt-3",
                onToggleMenu: _ctx.toggleMenu
              }, null, 8, ["title", "onToggleMenu"]),
              (_ctx.AbilityContext.isAuthorizedForAnyLicense('DP_WEBSITE_STARTER', 'DP_WEBSITE_BASIC', 'DP_WEBSITE_PREMIUM', 'PHARMACOLLECT_APB', 'PHARMACOLLECT_TEMPLATE', 'PHARMACOLLECT_PLUS_TEMPLATE', 'PHARMACOLLECT_PLUS_APB', 'DP_PHARMACY_GROUP_WEBSITE'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 22,
                    title: _ctx.$t('optionPacks'),
                    icon: "tv_options_edit_channels",
                    to: {name: 'licensing-option-pack'},
                    id: "menuItemOptionPacks",
                    onToggleMenu: _ctx.toggleMenu
                  }, null, 8, ["title", "onToggleMenu"]))
                : _createCommentVNode("", true),
              (_ctx.AbilityContext.isAuthorizedForAnyLicense('DP_WEBSITE_STARTER', 'DP_WEBSITE_BASIC', 'DP_WEBSITE_PREMIUM', 'PHARMACOLLECT_APB', 'PHARMACOLLECT_TEMPLATE', 'PHARMACOLLECT_PLUS_TEMPLATE', 'PHARMACOLLECT_PLUS_APB', 'DP_PHARMACY_GROUP_WEBSITE'))
                ? (_openBlock(), _createBlock(_component_MenuItem, {
                    key: 23,
                    title: "Helemaal mee!",
                    icon: "tips_and_updates",
                    to: {name: 'training'},
                    id: "menuItemTraining",
                    class: "mt-4",
                    onToggleMenu: _ctx.toggleMenu
                  }, null, 8, ["onToggleMenu"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("nav", _hoisted_16, [
        _createElementVNode("button", {
          class: "show-hide-menu-button bg-primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showMenu && _ctx.showMenu(...args)))
        }, ">>")
      ]))
}